import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BookingDataService from "../../services/Booking";
import ExpertDataService from "../../services/Expert";
import { FiSettings } from "react-icons/fi";
import { SetPageSizeModal } from "../../components/Modals/SetPageSizeModal";
import { useDisclosure, useToast } from "@chakra-ui/react";
import { MdOutlineFileDownload } from "react-icons/md";
import { HiOutlineUsers } from "react-icons/hi";

import { SingleExpertSheetRow } from "../../components/List/SingleExpertSheetRow";
import DownloadExpertBilingModal from "../../components/Modals/DownloadExpertBilingModal";
import Select from "react-select";
import MonthlyDownloadSheet from "../../components/Modals/MonthlyDownloadSheet";
export const ExpertBilingSheet = () => {
  const toast = useToast();
  const token = localStorage.getItem("logged_in_user_token");
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [expertList, setExpertList] = useState<any>([]);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [expert, setExpert] = useState("");
  const options = expertList.map((el: any) => ({
    value: el._id,
    label: el.data.full_name,
  }));
  const [list, setList] = useState<any>([]);
  const [modal, setModal] = useState<any>("");

  const [totalData, setTotalData] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const storedcontrols = localStorage.getItem("logged_in_user_accesscontrols");
  const userControls: any[] = storedcontrols ? JSON.parse(storedcontrols) : [];

  const handlePageSize = (input: number, islock: boolean) => {
    setPageSize(input);
  };
  const fetchExperts = () => {
    ExpertDataService.getExperts(token)
      .then((res: any) => {
        setExpertList(res.data);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const fetchData = async () => {
    try {
      const paymentDetailsResponse =
        await BookingDataService.getExpertBilingData(
          page,
          pageSize,
          token,
          expert
        );
      setTotalPages(paymentDetailsResponse.data.totalPages);
      setTotalData(paymentDetailsResponse.data.totalBookings);
      setList(paymentDetailsResponse.data.data);
    } catch (error: any) {
      if (error.response.status === 401) {
        toast({
          position: "top",
          title: "Authentication Failed.",
          description: "Your session is expired.",
          status: "error",
          duration: 500,
          isClosable: true,
        });
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
      console.log(error);
    }
  };

  const downloadMonthlySheet = () => {};

  useEffect(() => {
    fetchExperts();
  }, []);
  useEffect(() => {
    fetchData();
  }, [page, pageSize, expert]);
  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Billing - Expert Billing</div>
      <div className="p-4">
        <div className="top_section_container">
          <div className="expert_container_item expert_list_button ">
            <div className="nested p-lg-0 form-group col-md-8">
              <Select
                id="expert"
                name="expert"
                options={options}
                placeholder="Choose Expert"
                isClearable
                value={options.find((option: any) => option.value === expert)}
                onChange={(option: any) =>
                  setExpert(option ? option.value : "")
                }
              />
            </div>
          </div>
          <div className="expert_container_item expert_list_button ">
            <div className="btn-group" role="group">
              {!userControls.includes("hideBillingPayments") && (
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => {
                    setModal("monthlysheet");
                    onOpen();
                  }}
                >
                  Download Monthly Sheet
                </button>
              )}

              <button
                type="button"
                className="btn action-btn"
                onClick={() => {
                  setModal("setPageSize");
                  onOpen();
                }}
              >
                <FiSettings style={{ fontSize: "20px", margin: "0 5px" }} />
              </button>

              {!userControls.includes("hideBillingPayments") && (
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => {
                    setModal("downloadModal");
                    onOpen();
                  }}
                >
                  <MdOutlineFileDownload
                    style={{ fontSize: "20px", margin: "0 5px" }}
                  />
                </button>
              )}
              {!userControls.includes("hideBillingPayments") && (
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => {
                    navigate("/billing/userbilling/expertprices");
                  }}
                >
                  <HiOutlineUsers
                    style={{ fontSize: "20px", margin: "0 5px" }}
                  />
                </button>
              )}
              {modal === "setPageSize" && (
                <SetPageSizeModal
                  isOpen={isOpen}
                  onClose={onClose}
                  input={pageSize}
                  func={handlePageSize}
                />
              )}

              {modal === "downloadModal" && (
                <DownloadExpertBilingModal isOpen={isOpen} onClose={onClose} />
              )}

              {modal === "monthlysheet" && (
                <MonthlyDownloadSheet isOpen={isOpen} onClose={onClose} />
              )}
            </div>

            {/* <div className="btn-group" role="group">
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => syncPayments()}
                >
                  {syncLoader ? <Spinner size="sm" /> : "Sync Payments"}
                </button>
              </div> */}
          </div>
        </div>

        {/* Main secttion */}
        <div className="main-section" style={{ overflowX: "auto" }}>
          <table className="table">
            <thead>
              <tr>
                <th>Year</th>
                <th>Month</th>
                <th>Booking Id</th>
                <th>Date Time</th>
                <th>Session Type</th>
                <th>Source</th>
                <th>Client Email</th>
                <th>Client Name</th>
                <th>Service</th>
                <th>Type</th>
                <th>Expert Name</th>
                <th>Booking Status</th>
                <th>Post Session Status</th>
                {!userControls.includes("hideBillingPayments") && (
                  <th>Expert Payment</th>
                )}
              </tr>
            </thead>
            <tbody>
              {list && list.length > 0 ? (
                list.map((el: any) => (
                  <SingleExpertSheetRow key={el._id} data={el} />
                ))
              ) : (
                <h1 className="no-data">No Data Found</h1>
              )}
            </tbody>
          </table>
        </div>
        <div className="row m-0 pagination pt-5">
          <div className="col-sm-6 p-lg-0">
            <p>
              Showing {(page - 1) * pageSize + 1} to{" "}
              {page * pageSize > totalData ? totalData : page * pageSize} of{" "}
              {totalData} entries
            </p>
          </div>
          <div className="col-sm-6 p-lg-0 text-right">
            <div className="btn-group" role="group">
              <button
                type="button"
                className={
                  page === 1
                    ? "btn action-btn disabledButton "
                    : "btn action-btn"
                }
                onClick={() => setPage(page - 1)}
                disabled={page === 1 ? true : false}
              >
                {"<< Previous"}
              </button>
              <button type="button" className="btn action-btn selected">
                {page}
              </button>
              <button
                type="button"
                className={
                  page === totalPages || totalPages === 0
                    ? "btn action-btn disabledButton "
                    : "btn action-btn"
                }
                onClick={() => setPage(page + 1)}
                disabled={
                  page === totalPages || totalPages === 0 ? true : false
                }
              >
                {"Next >>"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
